/**
 * Onboarding wizard drafts use keys `form-draft-onboarding-${role}-step-${stepId}`.
 * Never persist secrets to localStorage; clear all such drafts after successful Clerk completion.
 */

const FORM_DRAFT_PREFIX = 'form-draft-onboarding-';

/** Keys that must never be written to localStorage from onboarding drafts. */
const SENSITIVE_DRAFT_FIELD_KEYS = [
  'password',
  'confirmPassword',
  'routingNumber',
  'accountNumber',
  'confirmAccountNumber',
  'taxId',
  'taxIdNumber',
  'signature',
  'upload_token',
] as const;

export function redactSensitiveFormFields<T extends Record<string, unknown>>(values: T): T {
  const out = { ...values } as Record<string, unknown>;
  for (const k of SENSITIVE_DRAFT_FIELD_KEYS) {
    if (k in out) delete out[k];
  }
  return out as T;
}

/** Remove every persisted onboarding step draft (and meta) from localStorage. */
export function clearOnboardingWizardFormDrafts(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(FORM_DRAFT_PREFIX)) keys.push(k);
    }
    for (const k of keys) {
      localStorage.removeItem(k);
      localStorage.removeItem(`${k}-meta`);
    }
  } catch {
    // ignore quota / access errors
  }
}
